var map = {
	"./movement/level-0.png": 64476,
	"./movement/level-1.png": 389,
	"./movement/level-2.png": 72558,
	"./movement/level-3.png": 72055,
	"./movement/level-4.png": 49912,
	"./movement/level-5.png": 71041,
	"./movement/level-6.png": 29962,
	"./movement/level-7.png": 61875,
	"./movement/level-8.png": 19604,
	"./movement/level-9.png": 40733,
	"./nutrition/level-0.png": 25447,
	"./nutrition/level-1.png": 49662,
	"./nutrition/level-2.png": 70037,
	"./nutrition/level-3.png": 58412,
	"./nutrition/level-4.png": 7811,
	"./nutrition/level-5.png": 17978,
	"./nutrition/level-6.png": 94225,
	"./nutrition/level-7.png": 45832,
	"./nutrition/level-8.png": 92895,
	"./nutrition/level-9.png": 39094,
	"./stress/level-0.png": 69875,
	"./stress/level-1.png": 14666,
	"./stress/level-2.png": 45249,
	"./stress/level-3.png": 24120,
	"./stress/level-4.png": 56759,
	"./stress/level-5.png": 27534,
	"./stress/level-6.png": 81541,
	"./stress/level-7.png": 98652,
	"./stress/level-8.png": 24491,
	"./stress/level-9.png": 3362
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21252;